import { e360Api } from "../../modules/Axios/api";
import type { ItemRastreado } from "./telas";

/**
 * `POST /integracao/acessos` do e360. Usuário, empresa e sistema saem do token
 * do Keycloak que já vai no cabeçalho; o corpo leva só a tela e a função.
 */
export const enviarAcessoE360 = async (
    tela: ItemRastreado,
    funcao?: ItemRastreado,
): Promise<void> => {
    await e360Api.post("/integracao/acessos", funcao ? { tela, funcao } : { tela });
};
